import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  inject,
  model,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { TranslateService, Translation } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientService } from '@core/services/patient.service';
import { assets } from '@core/constants';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ButtonComponent } from '@shared/components';
import { APIService } from '@core/services';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs';
import { Profile } from '@core/interfaces';
import { Roles } from '@auth';
import { NgOptimizedImage } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'ncp-patient-menu',
  imports: [ButtonComponent],
  templateUrl: './patient-menu.component.html',
  styleUrl: './patient-menu.component.scss',
})
export class PatientMenuComponent implements OnInit {
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly translate = inject(TranslateService);
  protected readonly router = inject(Router);
  protected activatedRoute = inject(ActivatedRoute);
  protected country$ = this.activatedRoute.params.pipe(map((p) => p['country']));
  protected currentCountry?: String;
  protected translations: Translation = this.translate.instant('patient.menu');
  protected readonly nationalSrc = assets.img.home.national.src;
  protected readonly europeanSrc = assets.img.home.european.src;
  protected readonly profileSrc = assets.img.home.profile.src;

  profile = JSON.parse(sessionStorage.getItem('profile')!) as Profile;

  ngOnInit(): void {
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('patient.menu');
    });

    this.country$.subscribe((country) => {
      this.currentCountry = country;
    });
  }

  protected goToPS = () => {
    if (this.currentCountry) {
      this.router.navigate(['eu', this.currentCountry, 'patient', 'ps']);
    }
  };

  protected goToEP = () => {
    if (this.currentCountry) {
      this.router.navigate(['eu', this.currentCountry, 'patient', 'ep']);
    }
  };

  protected goToORCD = () => {
    if (this.currentCountry) {
      this.router.navigate(['eu', this.currentCountry, 'patient', 'orcd']);
    }
  };

  protected goToVac = () => {
    if (this.currentCountry) {
      // this.router.navigate(['eu', this.currentCountry, 'patient', 'orcd']);
      console.log('Go to EU Vac');
    }
  };

  protected readonly Roles = Roles;
  protected readonly assets = assets;
}
